import { useAppSelector } from "../../Hooks/Hooks";
import {
    selectAllUserAvatars,
    selectAllUserSkillData,
    selectUserInventories,
    selectUserSkills,
} from "../../Redux/Data/DataSlice";
import { UserSkillObject } from "../../Types/DataTypes";
import { useEffect, useState } from "react";
import { FakeCheckBox, SpanOne, SpanTwo, SpanThree } from "../Menu/MobileMenuStyle";
import {
    LeaderBoardTitle,
    LeaderboardContainer,
    LeaderboardHeader,
    LeaderboardHeaderItem,
    LeaderboardList,
    LeaderboardMenuBar,
    LeaderboardMenuOption,
    MenuBurgerHolder,
} from "./LeaderboardStyle";
import { LeaderboardUserComponent } from "./LeaderboardUserComponent";

const exclude = "LiquiBot";
const excludedNames = ["nUkLdEePnUrMom", "expertki", "fuck", "shit", "bawls"];
const extraNames = ["zzLeet_", "TraiN", "fBomB", "sheezsh", "Devix"];

const appropriateName = (name: string) => {
    let badNameIndex = 0;
    if (
        excludedNames.filter((value, idx) => {
            if (name.includes(value)) {
                badNameIndex = idx;
            }
            return name.includes(value);
        }).length > 0
    ) {
        return extraNames[badNameIndex];
    } else {
        return name;
    }
};
export const Leaderboard = () => {
    const skills = useAppSelector(selectUserSkills);
    const userLevels = useAppSelector(selectAllUserSkillData);
    const userAvatars = useAppSelector(selectAllUserAvatars);
    const userInventories = useAppSelector(selectUserInventories);
    const [menuClicked, setMenuClicked] = useState<boolean>(false);
    const [whichSkillToDisplay, setWhichSkillToDisplay] = useState<string>("activity_level");
    const [sortedUsers, setSortedUsers] = useState<UserSkillObject | undefined>();

    const handleMenuClick = (e: React.MouseEvent<HTMLDivElement>) => {
        const target = e.target as HTMLDivElement;
        setWhichSkillToDisplay((target.innerText + "_level").toLowerCase());
    };

    useEffect(() => {
        if (userLevels) {
            const tempCopy = [...userLevels];
            setSortedUsers([
                ...tempCopy
                    ?.sort((a, b) => a.skills[whichSkillToDisplay] - b.skills[whichSkillToDisplay])
                    .reverse()
                    .filter((user) => !user.name.includes(exclude)),
            ]);
        }
    }, [whichSkillToDisplay, userLevels]);

    return (
        <LeaderboardContainer>
            <LeaderBoardTitle>
                <MenuBurgerHolder>
                    <FakeCheckBox
                        type="checkbox"
                        onClick={() => setMenuClicked(!menuClicked)}
                        $active={menuClicked}
                    />
                    <SpanOne $active={menuClicked} />
                    <SpanTwo $active={menuClicked} />
                    <SpanThree $active={menuClicked} />
                </MenuBurgerHolder>
                Leaderboards
            </LeaderBoardTitle>
            <LeaderboardMenuBar $active={menuClicked}>
                {skills?.map((skill, idx) => {
                    return !skill.includes("xp") && !skill.includes("max") ? (
                        <LeaderboardMenuOption
                            onClick={(e: React.MouseEvent<HTMLDivElement>) => handleMenuClick(e)}
                            key={idx}
                        >
                            {skill.split("_")[0]}
                        </LeaderboardMenuOption>
                    ) : (
                        ""
                    );
                })}
            </LeaderboardMenuBar>
            <LeaderboardHeader>
                <LeaderboardHeaderItem>Users</LeaderboardHeaderItem>
                <LeaderboardHeaderItem>{whichSkillToDisplay.split("_")[0]}</LeaderboardHeaderItem>
            </LeaderboardHeader>
            <LeaderboardList>
                {sortedUsers?.map((user, idx) => {
                    const userAvatarObject = userAvatars?.filter((object) => object.name === user.name);
                    const userInventory = userInventories?.filter((object) => object.name === user.name);
                    return (
                        <LeaderboardUserComponent
                            userObject={user}
                            appropriateName={appropriateName(user.name)}
                            avatarObject={userAvatarObject}
                            inventoryObject={userInventory}
                            whichSkillToDisplay={whichSkillToDisplay}
                            key={idx}
                        />
                    );
                })}
            </LeaderboardList>
        </LeaderboardContainer>
    );
};
